module.exports = __webpack_public_path__ + "close-icon.c30463a5.png";